// charge.styles.js — 1:1급여 정산 탭(진행 상태 카드·직원 목록·직원 상세) 스타일 (2026-10-06 UX)
//   마케터 정산서와 같이 쓰는 MonthlyCalculationPanel.styles.js 는 건드리지 않으려고 따로 둔다.
const TONE = {
  warn: { bg: 'rgba(245,158,11,0.14)', fg: '#b45309', bd: 'rgba(245,158,11,0.35)' },
  danger: { bg: 'rgba(220,38,38,0.10)', fg: '#dc2626', bd: 'rgba(220,38,38,0.30)' },
  ok: { bg: 'rgba(22,163,74,0.12)', fg: '#15803d', bd: 'rgba(22,163,74,0.30)' },
  blue: { bg: 'rgba(37,99,235,0.10)', fg: '#2563eb', bd: 'rgba(37,99,235,0.28)' },
  muted: { bg: 'rgba(100,116,139,0.12)', fg: 'var(--text-muted)', bd: 'var(--border)' },
};

export const C = {
  tone: TONE,
  card: { border: '1px solid var(--border)', borderRadius: 12, background: 'var(--bg-card)', minWidth: 0 },
  // ── 진행 상태 카드 ──
  status: { padding: 16, display: 'flex', flexDirection: 'column', gap: 12, borderBottom: '1px solid var(--border)', background: 'var(--bg-subtle)' },
  statusTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' },
  monthTitle: { fontSize: 18, fontWeight: 900, color: 'var(--text)' },
  monthRange: { marginLeft: 6, fontSize: 13, fontWeight: 700, color: 'var(--text-muted)' },
  monthHint: { marginTop: 4, fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.5 },
  stateChip: (tone) => ({
    display: 'inline-flex', alignItems: 'center', gap: 6, borderRadius: 999, padding: '5px 11px',
    background: TONE[tone].bg, color: TONE[tone].fg, border: `1px solid ${TONE[tone].bd}`, fontSize: 12, fontWeight: 800,
  }),
  steps: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(220px, 100%), 1fr))', gap: 8 },
  step: (tone) => ({
    border: `1px solid ${tone ? TONE[tone].bd : 'var(--border)'}`, borderRadius: 12, padding: '10px 12px',
    background: tone ? TONE[tone].bg : 'var(--bg-card)', display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0,
  }),
  stepNo: { fontSize: 11, fontWeight: 800, color: 'var(--text-muted)' },
  stepMain: { fontSize: 14, fontWeight: 800, color: 'var(--text)' },
  stepSub: { fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.45 },
  dateInput: {
    height: 40, border: '1px solid var(--border)', borderRadius: 10, padding: '0 10px', background: 'var(--bg-card)',
    color: 'var(--text)', fontSize: 14, maxWidth: 180, boxSizing: 'border-box',
  },
  actionRow: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' },
  primaryBtn: (disabled) => ({
    minHeight: 44, border: 'none', borderRadius: 12, padding: '0 18px',
    background: disabled ? 'rgba(15,23,42,0.35)' : 'var(--std-btn, #0f172a)', color: '#fff',
    fontSize: 14, fontWeight: 800, cursor: disabled ? 'default' : 'pointer',
  }),
  dangerOutlineBtn: {
    minHeight: 44, border: '1px solid rgba(220,38,38,0.35)', borderRadius: 12, padding: '0 16px', background: 'var(--bg-card)',
    color: '#dc2626', fontSize: 14, fontWeight: 800, cursor: 'pointer',
  },
  outlineBtn: {
    minHeight: 40, border: '1px solid var(--border)', borderRadius: 10, padding: '0 14px', background: 'var(--bg-card)',
    color: 'var(--text-sub)', fontSize: 13, fontWeight: 700, cursor: 'pointer',
  },
  smallLinkBtn: {
    minHeight: 40, border: 'none', background: 'transparent', color: '#2563eb', fontSize: 13, fontWeight: 800,
    cursor: 'pointer', padding: '0 4px',
  },
  blockReason: { fontSize: 12, color: '#b45309', fontWeight: 700 },
  totalRow: { display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap' },
  totalLabel: { fontSize: 13, color: 'var(--text-muted)', fontWeight: 700 },
  totalValue: { fontSize: 22, fontWeight: 900, color: 'var(--text)' },
  totalFormula: { fontSize: 12, color: 'var(--text-muted)' },
  metrics: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(150px, 100%), 1fr))', gap: 8 },
  metric: { border: '1px solid var(--border)', borderRadius: 10, padding: '8px 10px', background: 'var(--bg-card)' },
  metricLabel: { fontSize: 11, color: 'var(--text-muted)', fontWeight: 700 },
  metricValue: { marginTop: 2, fontSize: 15, fontWeight: 900, color: 'var(--text)' },
  error: {
    border: '1px solid rgba(220,38,38,0.25)', borderRadius: 10, padding: '10px 12px', background: 'rgba(220,38,38,0.08)',
    color: '#dc2626', fontSize: 13, fontWeight: 700, lineHeight: 1.5,
  },
  // ── 목록·상세 ──
  workspace: { display: 'grid', gridTemplateColumns: 'minmax(260px, 340px) minmax(0, 1fr)', gap: 12, padding: 12, alignItems: 'start' },
  listWrap: { display: 'flex', flexDirection: 'column', gap: 8, minWidth: 0 },
  listHead: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 },
  listTitle: { fontSize: 14, fontWeight: 900, color: 'var(--text)' },
  filters: { display: 'flex', gap: 6, flexWrap: 'wrap' },
  filterChip: (active) => ({
    minHeight: 40, borderRadius: 999, padding: '0 12px', fontSize: 12, fontWeight: 800, cursor: 'pointer',
    border: active ? '1px solid #2563eb' : '1px solid var(--border)', background: active ? 'rgba(37,99,235,0.10)' : 'var(--bg-card)',
    color: active ? '#2563eb' : 'var(--text-sub)',
  }),
  personCard: (active) => ({
    width: '100%', textAlign: 'left', border: active ? '2px solid #2563eb' : '1px solid var(--border)', borderRadius: 12,
    padding: active ? '9px 11px' : '10px 12px', background: active ? 'rgba(37,99,235,0.06)' : 'var(--bg-card)', cursor: 'pointer',
    display: 'flex', flexDirection: 'column', gap: 4, minHeight: 56, boxSizing: 'border-box',
  }),
  personTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 },
  personName: { fontSize: 14, fontWeight: 900, color: 'var(--text)', minWidth: 0 },
  personAmount: { fontSize: 14, fontWeight: 900, color: 'var(--text)', whiteSpace: 'nowrap' },
  personMeta: { fontSize: 12, color: 'var(--text-muted)' },
  badge: (tone) => ({
    alignSelf: 'flex-start', borderRadius: 999, padding: '2px 9px', fontSize: 11, fontWeight: 800,
    background: TONE[tone].bg, color: TONE[tone].fg,
  }),
  empty: { padding: 20, textAlign: 'center', fontSize: 13, color: 'var(--text-muted)' },
  // ── 직원 상세 ──
  detail: { display: 'flex', flexDirection: 'column', gap: 12, minWidth: 0 },
  detailHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10, flexWrap: 'wrap' },
  detailName: { fontSize: 18, fontWeight: 900, color: 'var(--text)' },
  detailSub: { marginTop: 3, fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.5 },
  lockBand: {
    border: '1px solid var(--border)', borderRadius: 10, padding: '9px 12px', background: 'var(--bg-subtle)',
    color: 'var(--text-sub)', fontSize: 13, fontWeight: 700, lineHeight: 1.5,
  },
  section: { border: '1px solid var(--border)', borderRadius: 12, padding: 12, background: 'var(--bg-card)', display: 'flex', flexDirection: 'column', gap: 8, minWidth: 0 },
  sectionTitle: { fontSize: 14, fontWeight: 900, color: 'var(--text)' },
  sectionHint: { fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.5 },
  chips: { display: 'flex', gap: 6, flexWrap: 'wrap' },
  chip: (tone) => ({ borderRadius: 999, padding: '3px 10px', fontSize: 12, fontWeight: 700, background: TONE[tone].bg, color: TONE[tone].fg }),
  footBtns: { display: 'flex', gap: 8, flexWrap: 'wrap' },
};
